import Navigation from "../../../header";
import { Container } from "@mui/material";

const ShipmentReportByMaterial = () => {
	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<h1 className="report-header">Shipment Report by Material</h1>
				<iframe title="HWIOnline_ShipmentReportByMaterial" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=de31ccf1-1f1c-45ef-9e2b-0c38f7505ed6&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe>
			</Container>
		</>
	);
};

export default ShipmentReportByMaterial;